import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "like"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  id: "a",
  d: "M17 4c-2 0-3.7 1.6-4.5 2.5-.8-1-2.6-2.5-4.4-2.5C4.9 4 3 6 3 9.4c0 2.8 2.3 5.1 2.4 5.2l6.5 6.9c.4.3.8.3 1.2 0l6.5-6.9S22 12.2 22 9.4C22 6 20.1 4 17 4z"
})));